import styled from 'styled-components';

import {SectionHeaderSEO} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

const HotelNameText = styled(SectionHeaderSEO)(
  props => `
  padding:${props.theme.spacing.base} 0;
  padding-bottom: 0.5rem;
  ${
    props.isUnif
      ? `-webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding-bottom:0px;`
      : ``
  }
`,
);

function HotelName({hotelName, isUnif = false, isSeoUnif = false}) {
  if (isSeoUnif) {
    return (
      <HotelNameText id="seoH1DontRemoveContainer" itemProp="name">
        {__CLIENT__ && window?.hotelsseocms?.h1Header}
      </HotelNameText>
    );
  }
  return <HotelNameText itemProp="name">{hotelName}</HotelNameText>;
}

export default HotelName;
